const mistakes = [
  { icon: "ri-time-line", title: "Starting Too Late for ETSU Study Abroad", description: "ETSU semester program deadlines come up fast. Many students don't realize a passport takes 1–3 months at the post office. Start at least 3 months before your program — or call us for expedited service." },
  { icon: "ri-image-line", title: "Wrong Passport Photo Format", description: "Johnson City CVS and Walgreens photos occasionally don't meet the 2x2 inch, white background, plain expression standard. Always verify before submitting. We provide a photo check service." },
  { icon: "ri-file-list-3-line", title: "Missing Birth Certificate", description: "First-time Johnson City applicants frequently arrive at the post office without their birth certificate or with a hospital souvenir copy (which isn't valid). The official state-issued certificate is required." },
  { icon: "ri-user-line", title: "Name Discrepancy on Documents", description: "ETSU students and recent Washington County newlyweds often have name changes that don't match all documents. Bring your marriage certificate, divorce decree, or legal name change documents." },
  { icon: "ri-map-pin-line", title: "Driving to Knoxville Without an Appointment", description: "The Knoxville Passport Agency does not accept walk-ins. Johnson City residents who make the 100-mile drive without an appointment are turned away. Our service eliminates this risk entirely." },
  { icon: "ri-calendar-line", title: "Underestimating Processing Time", description: "Standard post office processing for Johnson City residents can take 10–13 weeks during peak season. If your Mountain States medical conference or ETSU exchange is within 3 months, use our expedited service." },
];

export default function JohnsonCityMistakesSection() {
  return (
    <section id="mistakes" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Mistakes Johnson City Applicants Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Avoid these six common mistakes that cause Johnson City and Washington County passport applications to be rejected or delayed.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-xl p-7">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-red-100 flex-shrink-0">
                  <i className={`${m.icon} text-red-500 text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-semibold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-[#F6C344] rounded-xl p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#1A365D]/10 flex-shrink-0">
            <i className="ri-shield-check-line text-[#1A365D] text-2xl"></i>
          </div>
          <div className="flex-1">
            <h4 className="font-semibold text-[#1A365D] text-lg mb-1">We Catch Mistakes Before They Cost You</h4>
            <p className="text-[#1A365D]/70 text-sm leading-relaxed">
              Every application we handle goes through a full document review before submission. We catch photo errors, missing documents, and name discrepancies before they cause a rejection — saving Johnson City travelers weeks of delays.
            </p>
          </div>
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#1A365D] text-white font-semibold px-6 py-3 rounded-lg hover:bg-[#1A365D]/90 transition-all whitespace-nowrap flex-shrink-0">
            Start Without Mistakes <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}